import component from 'svelte-tag';
import Component from './Login/Login.wc.svelte';

//customElements.define('storytel-login', Component);
new component({
  component: Component,
  tagname: 'storytel-login',
  href: '',
  attributes: [
    'env',
    'country',
    'countryid',
    'language',
    'forgotpasswordlink',
    'redirecturl',
    'signuplink',
  ],
  shadow: false,
});
